import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import Button from "@mui/material/Button";

const BannerStaticConfirmation = ({
  showStaticModal,
  handleStatic,
  handleCancel,
}) => {
  return (
    <Dialog
      open={showStaticModal}
      onClose={handleCancel}
      className="delete-modalTemp delete-modal"
      aria-labelledby="form-dialog-title"
      overlayStyle={{ backgroundColor: "transparent" }}>
      <DialogContent>
        <div className="delete-modalheading">
          <span>{"Confirmation"}</span>
        </div>
        <div className="delete-modalSubHeading">
          Do you want to add static image in the banner PDF?
        </div>
        <div className="delete-modalContent"></div>
      </DialogContent>
      <DialogActions className="delete-actionsTemp">
        <Button
          onClick={handleCancel}
          color="primary"
          className="no-btn"
        >
          NO
        </Button>
        <Button
          onClick={() => handleStatic(true)}
          type="submit"
          className="btn btn-primary"
          autoFocus
        >
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BannerStaticConfirmation;

